import { Mark } from '@tiptap/core';
export const Highlight = Mark.create({
    name: 'highlight',
    addOptions() {
        return {
            multicolor: false,
            HTMLAttributes: {}
        };
    },
    addAttributes() {
        return {
            color: {
                default: null,
                parseHTML: (element) => element.getAttribute('data-color') || element.style.backgroundColor,
                renderHTML: (attributes) => {
                    if (!attributes.color) {
                        return {};
                    }
                    // Only add background-color, let the style attribute handle text color if specified
                    return {
                        'data-color': attributes.color,
                        style: `background-color: ${attributes.color};`
                    };
                }
            },
            style: {
                default: null,
                parseHTML: (element) => element.getAttribute('style'),
                renderHTML: (attributes) => {
                    if (!attributes.style) {
                        return {};
                    }
                    return {
                        style: attributes.style
                    };
                }
            }
        };
    },
    parseHTML() {
        return [
            {
                tag: 'mark',
                getAttrs: (node) => {
                    if (typeof node === 'string') {
                        return false;
                    }
                    const element = node;
                    const style = element.getAttribute('style');
                    const attrs = {};
                    // Preserve additional inline styles if present
                    if (style) {
                        attrs.style = style;
                    }
                    return attrs;
                }
            }
        ];
    },
    renderHTML({ HTMLAttributes }) {
        // Merge styles from different attributes
        const mergedAttributes = {
            ...this.options.HTMLAttributes,
            ...HTMLAttributes
        };
        // If both color attribute and style attribute have styles, merge them
        if (HTMLAttributes.style && HTMLAttributes['data-color']) {
            const styleFromColor = `background-color: ${HTMLAttributes['data-color']};`;
            const existingStyle = HTMLAttributes.style || '';
            // Merge styles, ensuring background-color from data-color is included
            if (!existingStyle.includes('background-color')) {
                mergedAttributes.style = `${styleFromColor} ${existingStyle}`.trim();
            }
            else {
                mergedAttributes.style = existingStyle;
            }
        }
        return ['mark', mergedAttributes, 0];
    },
    addCommands() {
        return {
            setHighlight: (attributes) => ({ commands }) => {
                return commands.setMark(this.name, attributes);
            },
            toggleHighlight: (attributes) => ({ commands }) => {
                return commands.toggleMark(this.name, attributes);
            },
            unsetHighlight: () => ({ commands }) => {
                return commands.unsetMark(this.name);
            }
        };
    }
});
